"use client";
import * as RadixToast from "@radix-ui/react-toast";
export default function ToastProvider(props: RadixToast.ToastProviderProps) {
    return (
      <RadixToast.Provider {...props}>{props.children}</RadixToast.Provider>
    )
  }